import { useMemo } from 'react'
import { PERMISSIONS, type PermissionKey } from '../constants/permissions'
import type { UserRole } from '../types'

interface UsePermissionsProps {
  userRole: UserRole | null
}

export const usePermissions = ({ userRole }: UsePermissionsProps) => {
  const hasPermission = useMemo(
    () => (permission: PermissionKey): boolean => {
      if (!userRole) return false
      return PERMISSIONS[permission].includes(userRole)
    },
    [userRole]
  )

  const hasAnyPermission = useMemo(
    () => (permissions: PermissionKey[]): boolean => {
      if (!userRole) return false
      return permissions.some(permission => PERMISSIONS[permission].includes(userRole))
    },
    [userRole]
  )

  const hasAllPermissions = useMemo(
    () => (permissions: PermissionKey[]): boolean => {
      if (!userRole) return false
      return permissions.every(permission => PERMISSIONS[permission].includes(userRole))
    },
    [userRole]
  )

  return {
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
  }
}
